exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button.favourite {\n  position: absolute;\n  bottom: 10px;\n  left: 10px;\n  border: none;\n  background-color: transparent;\n}\nbutton.favourite .icon img {\n  width: 30px;\n  height: 30px;\n  -webkit-filter: drop-shadow(6px 6px 6px rgba(95, 112, 128, 0.44));\n          filter: drop-shadow(6px 6px 6px rgba(95, 112, 128, 0.44));\n}", ""]);

// exports
